import selectCollection from "./collection"

export default function selectProcess(state, engine, model, query) {
  const collection = selectCollection(state, engine, model, query)
  return collection ? collection.process : null
}
